import React, { useEffect, useState } from "react";
import { RCCAlert, RCCProgress } from "react-common-components";
import { useTranslation } from "src/context/Translations/context";
import { IContracts } from "src/pages/Config/BusinessGroup/interface";
import useEffectFetchData from "src/hooks/useEffectFetchData";
import Container from "./styles";
import { IComponentCardContractItemType } from "./interface";
import Loader from "../Loader";

const CardContractItemType = ({
	type,
	routeAPI,
	extraParams
}: IComponentCardContractItemType ) => {
	const { translate } = useTranslation();
	const [amount, setAmount] = useState(0);
	const [color, setColor] = useState("green");
	const [data, setData] = useState<IContracts>({} as IContracts);
	
	const getColor = (amountN: number) => {
		if(amountN > 1)
			return "red";
		if(amountN <= 1 && amountN > 0.75)
			return "yellow";
		return "green";
	};


	const { errorFetching,  loading } = useEffectFetchData<IContracts> (
		routeAPI ?? "BusinessGroup/GetSpecificContractItem", 
		extraParams ? {
			...extraParams
		} : {
			type
		},
		({ data: dataX }) => {
			setData(dataX);
		}
	);

	useEffect(() => {
		if(data.efa012Id <= 0)
			return;

		const amountN = data.efa012Valor > 0 ? data.quantityUtilized/data.efa012Valor : 0;
		setAmount(amountN);
		setColor(getColor(amountN));
	}, [data]);

	if(errorFetching)
		return <RCCAlert 
			color="red"
			title={translate("Atenção")}
			description={translate("Erro ao carregar dados")}
		/>;

	if(loading)
		return <Loader />;

	if(data.efa012Id <= 0)
		return <RCCAlert 
			title={translate("Atenção")}
			description={translate("Não encontrado")}
		/>;

	return(
		<Container color={color}>
			<span title={translate(data.efa016Descricao)}>{translate(data.efa016Descricao)}</span>
				
			{data.efa012Valor > 0 ? 
				<h2>
					{data.quantityUtilized} / {data.efa012Valor}
				</h2>: 
				<h2>{data.efa012Valor}</h2>
			}
			{data.quantityUtilized > 0 && (
				<RCCProgress 
					value={Number((amount * 100).toFixed(2))} 
					layout="line"
					color={`var(--${color})`}
				/>
			)}
		</Container>
	);};

export default CardContractItemType;
